import React, { useContext } from 'react';
import { Dialog, DialogContent, Tab, Tabs } from '@mui/material';
import styles from './index.module.scss';
import classNames from 'classnames';
import { ReactComponent as InjuryIcon } from '../../../../assets/icons/timeline/injuryIcon.svg';
import { ReactComponent as AchievementIcon } from '../../../../assets/icons/timeline/achievementIcon.svg';
import { ReactComponent as FallIcon } from '../../../../assets/icons/timeline/fallIcon.svg';
import { ReactComponent as SurgeryIcon } from '../../../../assets/icons/timeline/graySurgeryIcon.svg';
import EventForm from './EventForm';
import { eventModalContext } from '../index';
import useFeatureMap from '../../../../hooks/useFeatureMap';
import SurgeryForm from './SurgeryForm';
import ClinicalEventForm from '../../ClinicalEvents/Drawer/ClinicalEventForm';
import AddFallForm from './AddFallForm';

export enum eventType {
  surgery = 'surgery',
  fall = 'fall',
  injury = 'injury',
  achievement = 'achievement',
  other = 'other',
  monitoring = 'monitoring',
}

export default function NewEventModal() {
  const { eventUuid, setEventUuid, eventTab, setEventTab } = useContext(eventModalContext);
  const { rtm } = useFeatureMap();

  return (
    <Dialog open={!!eventUuid} onClose={() => setEventUuid()}>
      <div className={classNames('flex flex-col', styles.root)}>
        <div
          className={classNames(
            'flex flex-row justify-center items-center',
            styles.titleContainer,
          )}
        >
          <span className={styles.title}>{`${eventUuid === 'none' ? 'Add' : 'Edit'} event`}</span>
        </div>
        <DialogContent className={styles.content}>
          <div className={styles.tabs}>
            <Tabs
              onChange={(e, value) => {
                setEventTab(value);
                setEventUuid('none');
              }}
              classes={{
                indicator: styles.tabsIndicator,
              }}
              value={eventTab}
            >
              <Tab
                label="Surgery"
                icon={<SurgeryIcon />}
                className={styles.tab}
                classes={{
                  selected: styles.selected,
                  labelIcon: styles.labelIcon,
                }}
                value={eventType.surgery}
              />
              <Tab
                label="Fall"
                icon={<FallIcon />}
                classes={{
                  selected: styles.selected,
                }}
                className={styles.tab}
                value={eventType.fall}
              />
              <Tab
                label="Injury"
                icon={<InjuryIcon />}
                className={styles.tab}
                classes={{
                  selected: styles.selected,
                }}
                value={eventType.injury}
              />
              <Tab
                label="Achievement"
                icon={<AchievementIcon />}
                className={styles.tab}
                classes={{
                  selected: styles.selected,
                }}
                value={eventType.achievement}
              />
              <Tab
                label="Other"
                className={styles.tab}
                classes={{
                  selected: styles.selected,
                }}
                value={eventType.other}
              />
              {rtm?.write ? (
                <Tab
                  label="Monitoring"
                  className={styles.tab}
                  classes={{
                    selected: styles.selected,
                  }}
                  value={eventType.monitoring}
                />
              ) : null}
            </Tabs>
          </div>
          {eventTab === eventType.monitoring ? (
            <ClinicalEventForm newItem />
          ) : eventTab === eventType.surgery ? (
            <SurgeryForm />
          ) : eventTab === eventType.fall ? (
            <AddFallForm />
          ) : (
            <EventForm />
          )}
        </DialogContent>
      </div>
    </Dialog>
  );
}
